import {Ng2StateDeclaration, Transition} from '@uirouter/angular';
import { EdlRegistrationService, ValidatedRegistrationToken, EdlRegistrationComponent, EdlRegistrationCompleteComponent } from '@edl-development/edl-auth';


export function resolveProfileRegex(registrationService: EdlRegistrationService) {
    return registrationService
        .getProfileRegex()
        .toPromise();
}

export function resolveToken(registrationService: EdlRegistrationService, transition: Transition) {
    let params = transition.params();
    let token: string = params.token;

    if (token) {
        return registrationService
            .validateToken(token)
            .toPromise();
    } else {
        return Promise.resolve(() => new ValidatedRegistrationToken());
    }
}

export function resolveUsername(transition: Transition) {
    let params = transition.params();
    return params.username;
}

export function resolveError(registrationService: EdlRegistrationService, transition: Transition) {
    let params = transition.params();
    let token: string = params.token;

    return registrationService
        .verifyRegistration(token)
        .toPromise();
}

export let RegistrationStates: Ng2StateDeclaration[] = [{
  name: 'public.registration',
  url: '/registration',
  views: {
      'content@public': {
          component: EdlRegistrationComponent
      }
  },
  resolve: [{
      token: 'profileRegex',
      deps: [EdlRegistrationService],
      resolveFn: resolveProfileRegex
  }, {
      token: 'validatedRegistrationToken',
      deps: [EdlRegistrationService, Transition],
      resolveFn: resolveToken
  },{
    token: 'userCreationMode',
    deps: [EdlRegistrationService, Transition],
    resolveFn: () => 'newUser'
}]
},{
  name: 'public.sso-registration',
  url: '/registration',
  views: {
      'content@public': {
          component: EdlRegistrationComponent
      }
  },
  resolve: [{
      token: 'profileRegex',
      deps: [EdlRegistrationService],
      resolveFn: resolveProfileRegex
  }, {
      token: 'validatedRegistrationToken',
      deps: [EdlRegistrationService, Transition],
      resolveFn: resolveToken
  },{
    token: 'userCreationMode',
    deps: [EdlRegistrationService, Transition],
    resolveFn: () => 'sso'
}]
}, {
  name: 'public.registration-complete',
  url: '/registration-complete',
  views: {
      'content@public': {
          component: EdlRegistrationCompleteComponent
      }
  }
}, {
  name: 'public.account-validation',
  url: '/registration/details/:token',
  views: {
      'content@public': {
          component: EdlRegistrationComponent
      }
  },
  resolve: [{
      token: 'profileRegex',
      deps: [EdlRegistrationService],
      resolveFn: resolveProfileRegex
  }, {
      token: 'validatedRegistrationToken',
      deps: [EdlRegistrationService, Transition],
      resolveFn: resolveToken
  }, {
      token: 'userCreationMode',
      deps: [],
      resolveFn: () => 'newUser'
  }]
},

{
  name: 'public.sso-account-validation',
  url: '/registration/sso/:token',
  views: {
      'content@public': {
          component: EdlRegistrationComponent
      }
  },
  resolve: [{
      token: 'profileRegex',
      deps: [EdlRegistrationService],
      resolveFn: resolveProfileRegex
  }, {
      token: 'validatedRegistrationToken',
      deps: [EdlRegistrationService, Transition],
      resolveFn: resolveToken
  }, {
    token: 'userCreationMode',
    deps: [],
    resolveFn: () => 'sso'
}]
}];
